import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Flex,
  FlexItem
} from 'mailup-web-components'
import {
  changeWizardStepCallback,
  saveTaskCallback
} from 'Pages/Task/recoil/callbacks/callbacks'
import { modalSimulate } from 'Pages/Task/recoil/state/modals'
import {
  pageState,
  step1IsEnabledState,
  step2IsEnabledState,
  step3IsEnabledState,
  step4IsEnabledState
} from 'Pages/Task/recoil/state/page'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useResetRecoilState
} from 'recoil'
import { ModalSimulate } from '../Modals/ModalSimulate'
import Action from './components/Action'
import Conditions from './components/Conditions'
import EnableDisable from './components/EnableDisable'
import Frequency from './components/Frequency'
import InfoGeneral from './components/InfoGeneral'

const TaskStep5 = () => {
  const intl = useIntl()
  const history = useHistory()
  const changeWizardStep = useRecoilCallback(changeWizardStepCallback, [])
  const [{ show: showModalSimulate }, setModalSimulate] =
    useRecoilState(modalSimulate)
  const { idTask, exitPage } = useRecoilValue(pageState)
  const saveTask = useRecoilCallback(saveTaskCallback, [])
  const resetModalSimulate = useResetRecoilState(modalSimulate)
  const step1IsEnabled = useRecoilValue(step1IsEnabledState)
  const step2IsEnabled = useRecoilValue(step2IsEnabledState)
  const step3IsEnabled = useRecoilValue(step3IsEnabledState)
  const step4IsEnabled = useRecoilValue(step4IsEnabledState)

  const handleModalSimulateCancel = () => {
    resetModalSimulate()
  }
  const handleBack = () => {
    changeWizardStep(4)
  }

  const handleConfirm = () => {
    const save = async () => {
      await saveTask(true)
    }
    save()
  }

  useEffect(() => {
    exitPage && history.push(`/automation/tasks/list`)
  }, [exitPage])

  const handleSimulate = () => {
    setModalSimulate((prev) => ({
      ...prev,
      show: true,
      idTask,
      idSimulate: undefined,
      fetchData: false,
      currentIteration: 0,
      interval: 250,
      simulateStatus: undefined,
      simulateProcessed: undefined,
      simulateDiscarded: undefined
    }))
  }

  return (
    <>
      <ModalSimulate
        show={showModalSimulate}
        handleCancel={handleModalSimulateCancel}
      />
      <EnableDisable />
      <InfoGeneral />
      <Action />
      <Conditions />
      <Frequency />
      <Flex justifyContent='space-between'>
        <Button
          data-mu-test='task-5-btn-back'
          kind={BUTTON_VARIANT_SECONDARY}
          onClick={() => handleBack()}
        >
          {intl.formatMessage({ id: 'Load.Common.BtnBack' })}
        </Button>

        <Flex justifyContent='space-between' columnGap='8px'>
          <Button
            data-mu-test='task-5-btn-simulate'
            kind={BUTTON_VARIANT_SECONDARY}
            onClick={() => handleSimulate()}
            disabled={
              !step1IsEnabled ||
              !step2IsEnabled ||
              !step3IsEnabled ||
              !step4IsEnabled
            }
          >
            {intl.formatMessage({ id: 'Load.Task.ReviewSimulate' })}
          </Button>
          <FlexItem>
            <Button
              data-mu-test='task-5-btn-save'
              kind={BUTTON_VARIANT_PRIMARY}
              onClick={() => handleConfirm()}
              disabled={
                !step1IsEnabled ||
                !step2IsEnabled ||
                !step3IsEnabled ||
                !step4IsEnabled
              }
            >
              {intl.formatMessage({ id: 'Load.Task.SaveTask' })}
            </Button>
          </FlexItem>
        </Flex>
      </Flex>
    </>
  )
}

export default TaskStep5
